import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PersistOptions } from "zustand/middleware";
import type { LicenseTerms } from "~/types/api";

export interface LicenseState {
  license: LicenseTerms | null;

  setLicenseTerms: (license: LicenseTerms) => void;

  // Computed values
  isPermittedWhiteLabel: () => boolean;

  reset: () => void;
}

const useLicenseState = create<LicenseState>()(
  persist(
    (set, get) => ({
      license: null,

      setLicenseTerms: (license: object) => set(() => ({ license: license })),

      isPermittedWhiteLabel: () => {
        const whiteLabel = get().license?.WHITE_LABEL;
        return !!whiteLabel && whiteLabel.toLowerCase() === "true";
      },

      reset: () =>
        set(() => ({
          license: null,
        })),
    }),
    {
      name: "license-state",
    } as PersistOptions<LicenseState>,
  ),
);

export default useLicenseState;
